import { Spin } from "antd";
import { useCurrencies } from "hooks/useCurrencies";
import React from "react";
import { formatCurrency, CurrencyCode } from "utils/formatCurrency.ts";

import MoneyData = App.Data.MoneyData;

interface MoneyCellProps {
    money?: MoneyData | null;
    useFormattedAmount?: boolean;
}

export const MoneyCell: React.FC<MoneyCellProps> = ({ money, useFormattedAmount = false }) => {
    const { loading, error, get } = useCurrencies();

    if (!money) return <>-</>;

    if (useFormattedAmount) {
        return <>{money.formatted_amount}</>;
    }

    if (loading) return <Spin size="small" />;
    if (error) return <>{money.formatted_amount}</>;

    const currency = get(money.currency_id);
    if (!currency) {
        return <>{money.formatted_amount}</>;
    }

    const formatted = formatCurrency(money.amount, currency.currency_code as CurrencyCode);

    return <>{formatted}</>;
};
